const keys = {
  all: () => ["users"] as const,
  one: (id: string) => [...keys.all(), id] as const,
};

export default keys;
